import React, { useEffect, useState } from 'react';
import RenewalsApi from '../../../api/RenewalsApi';
import { AuthData } from '../../../context/auth';
import {
	RenewalData,
	withRenewalContext,
} from '../../../context/RenewalProvider';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../../common';
import DocumentsTable from '../../DocumentsTable';

interface Props {
	renewalData: RenewalData;
	authData: AuthData;
}

const DocumentsView = (props: Props) => {
	const {
		renewalData,
		authData: { auth },
	} = props;
	const { renewalUpdateObj } = renewalData;

	const [documents, setDocuments] = useState(renewalUpdateObj.documents);

	useEffect(() => {
		let timer: any = 0;
		const fetchRenewal = async () => {
			try {
				const updatedRenewal = await RenewalsApi.getRenewal(
					auth.authorizationToken,
					renewalUpdateObj.locator,
				);
				setDocuments(updatedRenewal.data.documents);
				if (
					updatedRenewal.data.documents &&
					!updatedRenewal.data.documents.every((d) => !!d.url)
				) {
					timer = setTimeout(() => {
						fetchRenewal();
					}, 30000);
				}
			} catch (err) {
				console.error(err);
			}
		};
		if (
			renewalUpdateObj.documents &&
			!renewalUpdateObj.documents.every((d) => !!d.url)
		) {
			fetchRenewal();
		}
		return () => clearTimeout(timer);
	}, []);

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Documents</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<DocumentsTable documents={documents} />
			</StyledSectionContainer>
		</>
	);
};

export default withRenewalContext<Props>(DocumentsView);
